/**
 * Controller: SherpaCustomersSignInModal
 */
angular.module('acme.view.application.sherpa.customers.signInModal.controllers', [])
.controller('SherpaCustomersSignInModalController', [ '$scope', '$uibModalInstance', 'currentTenant', function ($scope, $uibModalInstance, currentTenant) {

    $scope.errors = [];

    $scope.model = {
      id: currentTenant.id,
      name: currentTenant.name
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);